module.exports = __webpack_public_path__ + "h5/img/summer-backgroung_bottom.22eeb198.png";